/* KALINORA — interactions (vanilla, no libraries) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll + count-up (one shared observer) */
  function initReveal() {
    var els = document.querySelectorAll('.hq-reveal, [data-hq-count]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('hq-visible'); if (el.dataset.hqCount) setFinal(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('hq-visible');
        if (e.target.dataset.hqCount) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  function fmt(n, dec) {
    return Number(n).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }
  function setFinal(el) {
    el.textContent = fmt(parseFloat(el.dataset.hqCount), parseInt(el.dataset.hqDec || '0', 10));
  }
  function countUp(el) {
    var end = parseFloat(el.dataset.hqCount), dec = parseInt(el.dataset.hqDec || '0', 10);
    var dur = parseInt(el.dataset.hqDur || '1800', 10), t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt(end * eased, dec);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Modes accordion with optional autoplay */
  function initModes() {
    document.querySelectorAll('.hq-modes').forEach(function (root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.hq-mode'));
      if (!items.length) return;
      var auto = root.dataset.autoplay === 'true' && !reduce;
      var cycle = parseInt(root.dataset.cycle || '5', 10) * 1000;
      var idx = 0, timer = null, visible = false;
      function activate(i) {
        items.forEach(function (it, k) {
          it.classList.toggle('is-active', k === i);
          it.querySelector('.hq-mode__btn').setAttribute('aria-expanded', k === i ? 'true' : 'false');
        });
        idx = i;
      }
      function schedule() {
        clearTimeout(timer);
        if (auto && visible) timer = setTimeout(function () { activate((idx + 1) % items.length); schedule(); }, cycle);
      }
      items.forEach(function (it, k) {
        it.querySelector('.hq-mode__btn').addEventListener('click', function () { auto = false; root.dataset.autoplay = 'false'; activate(k); clearTimeout(timer); });
      });
      activate(0);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(root);
      }
    });
  }

  /* Before / after slider */
  function initBA() {
    document.querySelectorAll('.hq-ba__frame').forEach(function (frame) {
      var range = frame.querySelector('.hq-ba__range');
      if (!range) return;
      function set(v) { frame.style.setProperty('--hq-pos', v + '%'); }
      set(range.value);
      range.addEventListener('input', function () { set(range.value); });
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          io.disconnect();
          var start = parseFloat(range.value), t0 = null;
          function hint(t) {
            if (!t0) t0 = t;
            var p = Math.min((t - t0) / 1600, 1);
            var v = start + Math.sin(p * Math.PI * 2) * 14 * (1 - p);
            set(v);
            if (p < 1) requestAnimationFrame(hint); else set(range.value);
          }
          requestAnimationFrame(hint);
        }, { threshold: 0.5 });
        io.observe(frame);
      }
    });
  }

  /* Product gallery + variant picker + sticky add to cart */
  function initPDP() {
    var root = document.querySelector('[data-hq-pdp]');
    if (!root) return;
    var main = root.querySelector('.hq-pdp__main img');
    root.querySelectorAll('.hq-pdp__thumb').forEach(function (th) {
      th.addEventListener('click', function () {
        root.querySelectorAll('.hq-pdp__thumb').forEach(function (x) { x.classList.remove('is-active'); });
        th.classList.add('is-active');
        main.style.opacity = 0;
        setTimeout(function () { main.src = th.dataset.full; main.srcset = ''; main.alt = th.dataset.alt || ''; main.style.opacity = 1; }, 160);
      });
    });

    var json = root.querySelector('[data-hq-variants]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = root.querySelector('input[name="id"]');
    var addBtn = root.querySelector('[data-hq-add]');
    var priceNow = root.querySelectorAll('[data-hq-price]');
    var priceWas = root.querySelector('[data-hq-compare]');
    var soldOut = root.querySelector('.hq-sold-out');
    var fieldsets = root.querySelectorAll('[data-hq-option]');
    function money(cents) {
      var f = root.dataset.moneyFormat || '${{amount}}';
      var v = (cents / 100).toFixed(2);
      return f.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
    }
    function update() {
      if (!fieldsets.length) return;
      var chosen = Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
      if (!v) { addBtn.disabled = true; return; }
      idInput.value = v.id;
      priceNow.forEach(function (p) { p.textContent = money(v.price); });
      if (priceWas) { priceWas.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      addBtn.disabled = !v.available;
      if (soldOut) soldOut.hidden = v.available;
      if (v.featured_image && main) { main.src = v.featured_image.src; main.srcset = ''; }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

    var sticky = document.querySelector('.hq-sticky-atc');
    var buy = root.querySelector('.hq-pdp__buy');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buy);
      sticky.querySelector('button').addEventListener('click', function () { addBtn.click(); });
    }
  }

  /* Soft parallax on hero image */
  function initParallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('[data-hq-parallax]');
    if (!imgs.length) return;
    var ticking = false;
    function run() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.dataset.hqParallax || '0') / 100;
        var r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (r.top * -k).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(run); ticking = true; } }, { passive: true });
    run();
  }

  function init() { initReveal(); initModes(); initBA(); initPDP(); initParallax(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
